<template>
    <div :class="`quotelines-value column-${column} / flex`">
        <ShowMoreTextContent :lines="2">
            <template #text-content>
                {{ content }}
            </template>
        </ShowMoreTextContent>
    </div>
</template>

<script setup lang="ts">
    import {ShowMoreTextContent} from '~/common/ui';
    import type {FormattedQuoteLine} from './quote-lines.types';

    defineProps<{
        content: string | number;
        column: keyof FormattedQuoteLine;
    }>();
</script>

<style lang="scss" scoped>
    .quotelines-value {
        display: flex;
        width: 100%;
        max-width: 260px;
        min-width: 60px;
        justify-content: flex-end;
        text-align: end;

        &.column-title {
            justify-content: flex-start;
            text-align: start;
            width: 100%;
        }
    }
</style>
